module.exports = __webpack_public_path__ + "static/img/cloud.7263f7e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bquery/cloud.gif
// module id = uQd4
// module chunks = 2